module.exports = __webpack_public_path__ + "static/snake-26bd411edf059ea193c080fe53af1eaa.gif";